<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Item Name</label>
                  <div>
                    <model-list-select
                      :list="itemListFromApi"
                      v-model="form.dispatchitem"
                      option-value="itemid"
                      option-text="itemname"
                      placeholder="Select item"
                      isDisabled="true"
                    >
                    </model-list-select>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Branch</label>
                  <div>
                    <model-list-select
                      :list="branchList"
                      v-model="form.branch"
                      option-value="branchid"
                      option-text="branchname"
                      placeholder="Select branch"
                    >
                    </model-list-select>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Issue To</label>
                  <select class="form-control" v-model="form.issuedto" @change="handleIssuedToChange">
                    <option value="BRANCH">Branch</option>
                    <option value="DEALER">Dealer</option>
                  </select>
                </div>
              </div>
              <div v-if="form.issuedto === 'DEALER'" class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Dealer</label>
                  <div>
                    <model-list-select
                      :list="filteredDealers"
                      v-model="form.dealerid"
                      option-value="dealerid"
                      option-text="dealername"
                      placeholder="Select dealer"
                    >
                    </model-list-select>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Voucher Code</label>
                  <input type="text" v-model="form.vouchercode" />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Quantity</label>
                  <input type="text" v-model="form.quantity" />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Issue Date</label>
                  <div>
                    <b-form-input
                      type="date"
                      v-model="form.dispatchdate"
                      placeholder="Select dispatch date"
                    ></b-form-input>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-sm-12 col-12">
                <div class="form-group">
                  <label>Remarks</label>
                  <input type="text" v-model="form.remarks" placeholder="Optional" />
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Update</a>
                <router-link to="saleslist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ModelListSelect } from "vue-search-select"
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      form: {
        dispatchitem: '',
        quantity: '',
        vouchercode: '',
        branch: '',
        issuedto: 'BRANCH',
        dealerid: '',
        remarks: '',
        dispatchdate: '',
      },
      filter: true,
      id: this.$route.query.id,
      title: "Edit Issued Item",
      title1: "Edit Issue",
      branchList: [],
      dealerList: [],
      itemListFromApi: [],
    };
  },
  created(){
    this.fetchItemListFromApi();
    this.fetchBranchListFromApi();
    this.fetchDealerListFromApi();
  },
  methods: {
    async fetchItemListFromApi() {
    try {
      const response = await axios.get('/v1/items');
      this.itemListFromApi = response.data; // Update with your actual API response structure
    } catch (error) {
      console.error('Error fetching item list:', error);
      }
    },
    async fetchBranchListFromApi() {
    try {
      const response = await axios.get('/v1/branches');
      this.branchList = response.data;
    } catch (error) {
      console.error('Error fetching branch list:', error);
      }
    },
    async fetchDealerListFromApi() {
    try {
      const response = await axios.get('/v1/dealers');
      this.dealerList = response.data;
    } catch (error) {
      console.error('Error fetching dealer list:', error);
      }
    },
    handleIssuedToChange() {
      if (this.form.issuedto !== 'DEALER') {
        this.form.dealerid = '';
      }
    },
    postData() {
      if (!this.form.dispatchitem) {
        Swal.fire("Please enter the Issue Item");
        return;
      }

      if (!this.form.branch) {
        Swal.fire("Please select a branch");
        return;
      }
      if (this.form.issuedto === 'DEALER' && !this.form.dealerid) {
        Swal.fire("Please select a dealer");
        return;
      }
      if (!this.form.vouchercode) {
        Swal.fire("Please enter the Voucher Code");
        return;
      }
      const selectedDate = moment(this.form.dispatchdate).format("YYYY-MM-DD");
      const currentTime = moment().format("HH:mm:ss");

      const combinedDateTime = `${selectedDate} ${currentTime}`;

      this.form.dispatchdate = combinedDateTime;

      axios
      .put('/v1/dispatches/' + this.id, this.form)
      .then(response => {
        Swal.fire("Issue updated successfully");
        this.$router.push({ path: '/saleslist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getDispatchById(id) {
      try {
    const response = await axios.get('/v1/dispatches/' + id);
    this.form = response.data;

    if (this.form.dispatchdate) {
      const date = new Date(this.form.dispatchdate);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      this.form.dispatchdate = `${year}-${month}-${day}`;
    }
    } catch (error) {
      console.log(error);
      this.errored = true;
    }
  }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getDispatchById(this.id);
  },
  computed: {
    filteredDealers() {
      return this.dealerList.filter(dealer => (dealer.branchids || []).includes(this.form.branch));
    }
  },
  components: {
    ModelListSelect
  },
  name: "edit-sales",
};
</script>
